<template>
  <div class="browse-filter">
    <h5 v-if="name" @click="toggle">
      <span>{{ name }}</span>
      <img :src="collapsed ? downArrowIcon : upArrowIcon" alt="Hide">
    </h5>
    <div v-show="!collapsed">
      <slot />
    </div>
  </div>
</template>
<script>
import upArrowIcon from '~/static/list-item-up.svg';
import downArrowIcon from '~/static/list-item-down.svg';

export default {
  props: {
    name: {
      type: String,
      required: false,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      collapsed: !this.open && this.name,
      downArrowIcon,
      upArrowIcon,
    };
  },
  methods: {
    toggle() {
      this.collapsed = !this.collapsed;
    },
  },
};
</script>
<style scoped>
.browse-filter {
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.browse-filter:last-child {
  border-bottom: 0;
}

.browse-filter h5 {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  font-family: Barlow, sans-serif;
  color: #1b1b1b;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  user-select: none;
}

.browse-filter h5 span {
  user-select: none;
  cursor: pointer;
}

.browse-filter h5 img {
  outline: 0;
  cursor: pointer;
  user-select: none;
}
</style>
